import { useState, useEffect } from 'react'
import { useGetTokenMutation } from '../redux/api/authApi'

const useToken = () => {
  const [token, setToken] = useState<string>('')

  const [getToken, { isLoading }] = useGetTokenMutation()

  useEffect(() => {
    const fetchToken = async () => {
      await getToken()
      const cookie = document.cookie.match(/XSRF-TOKEN=([^%]+)/i)
      const xsrf = cookie !== null ? cookie[1].concat('=') : 'err'
      setToken(xsrf)
    }
    void fetchToken()
  }, [])

  return {
    xsrf: token,
    isLoading
  }
}

export default useToken
